import * as React from 'react';
import { Label } from '@cian/ui-kit';

import { GetOnlineButton } from '../GetOnlineButton';

interface ITitleColumnRightProps {
  isBlackFridayPromo: boolean | undefined;
  isGetOnlineButtonAvailable: boolean;
  mortgagePartnerLink: string;
  onGetOnlineButtonClick: (event: React.MouseEvent) => void;
}

export const TitleColumnRight: React.FC<ITitleColumnRightProps> = ({
  isBlackFridayPromo,
  isGetOnlineButtonAvailable,
  mortgagePartnerLink,
  onGetOnlineButtonClick,
}) => {
  if (isBlackFridayPromo) {
    return (
      <Label background="accent-main-primary" color="theme-white" data-testid="MortgageOfferBlackFridayLabel">
        Sale
      </Label>
    );
  }

  if (isGetOnlineButtonAvailable) {
    return <GetOnlineButton href={mortgagePartnerLink} onClick={onGetOnlineButtonClick} />;
  }

  return null;
};
